import { IExampleDrivers, IExampleLocation } from './interfaces';

const drivers: IExampleDrivers = {
  name: `Lima`,
  location: {
    lat: -12.046374,
    lng: -77.042793,
  },
  drivers: {
    label: [`Luis Miguel`, `Jorge Luis`, `José`],
    start_address: [
      `Calle Baltazar La Torre 380, San Isidro 15076, Lima, Perú`,
      `Calle Baltazar La Torre 380, San Isidro 15076, Lima, Perú`,
      `Calle Baltazar La Torre 380, San Isidro 15076, Lima, Perú`,
    ],
    end_address: [
      `Calle Baltazar La Torre 380, San Isidro 15076, Lima, Perú`,
      `Calle Baltazar La Torre 380, San Isidro 15076, Lima, Perú`,
      `Av Antonio José de Sucre 538, Magdalena del Mar 17, Lima, Perú`,
    ],
  },
};

const stops: IExampleLocation = {
  name: `Lima`,
  location: {
    lat: -12.046374,
    lng: -77.042793,
  },
  stops: {
    label: [
      `Central Restaurante`,
      `Saha Peruvian Kitchen`,
      `La Mar Restaurante`,
      `Panchita`,
      `Isolina Taberna Peruana`,
      `Mayta Lima`,
      `Rafael`,
      `Amoramar`,
      `Embarcadero 41 Fusión`,
      `Juanito de Barranco`,
    ],
    address: [
      `Av. Pedro de Osma 301, Barranco, Lima, Perú`,
      `Calle Bolívar 164, Miraflores 15074, Lima, Perú`,
      `Mariscal La Mar 770, Miraflores 15074, Lima, Perú`,
      `Calle 2 de Mayo 298, Miraflores 15074, Lima, Perú`,
      `Av San Martin 101, Barranco 15063, Lima, Perú`,
      `Av. Mariscal La Mar 1285, Miraflores 15027, Lima, Perú`,
      `Calle San Martin 300, Miraflores 15074, Lima, Perú`,
      `Av. Pardo y Aliaga 672, San Isidro 15073, Lima, Perú`,
      `Av. Mariscal La Mar 456, Miraflores 15074, Lima, Perú`,
      `Av. Almte. Miguel Grau 270, Barranco 15063, Perú`,
    ],
    address_details: [``, ``, ``, ``, ``, ``, ``, ``, ``, ``],
    delivery_label: [
      `Luis Alberto Quispe`,
      `Elizabeth Flores`,
      `Marco Antonio Rojas`,
      `María Isabel Díaz`,
      `Carlos Alberto Mendoza`,
      `Carmen Rosa León`,
      `Jorge Luís Silva`,
      `Rosa María Espinoza`,
      `Miguel Angel Reyes`,
      `María Pilar Gonzales`,
    ],
    delivery_address: [
      `Av. Javier Prado Este 2970, Cercado de Lima 15037, Lima, Perú`,
      `Av. República de Panamá 6222, Miraflores 15047, Lima, Perú`,
      `Calle Coronel Inclán 990, Miraflores 15074, Lima, Perú`,
      `Av. Caminos del Inca 2711, Cercado de Lima 15039, Lima, Perú`,
      `Av Pablo Carriquiry 798, San Isidro 15036, Lima, Perú`,
      `Av. Guardia Civil 482, San Isidro 15036, Lima, Perú`,
      `Av. Arequipa 330, Cercado de Lima 15046, Lima, Perú`,
      `Av. Alfredo Benavides 1967, Miraflores 15048, Lima, Perú`,
      `Av. Alfredo Benavides 4813, Santiago de Surco 15039, Lima, Perú`,
      `Av. Carlos Izaguirre 789, Los Olivos 15301, Lima, Perú`,
    ],
    delivery_address_details: [``, `Piso 3 Puerta 2`, ``, `Local 4`, ``, ``, `Planta 2`, ``, `Oficina 8`, ``],
  },
};

export { drivers, stops };
